export class LoginData {
    public Email: string;
    public Password: string;
}